function wrapCurency(){
  function wrapWordInSpan(priceNodeList, wordToWrap) {
    priceNodeList.forEach(element => {
      const text = element.textContent;
      const newText = text.replace(wordToWrap, `<span>${wordToWrap}</span>`);
      element.innerHTML = newText;
    });
  }

  const priceInner = document.querySelectorAll('.price--large .price-item');
  if (currencyElement.dataset.currency === 'CAD') {
    wrapWordInSpan(priceInner, 'CAD');
  } else if (currencyElement.dataset.currency === 'USD') {
    wrapWordInSpan(priceInner, 'USD');
  }
}

